// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../css-loader/index.js!../../../sass-loader/lib/loader.js!../../../postcss-loader/lib/index.js!./swiper.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../vue-style-loader/lib/addStylesClient.js")("b39bdd22", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./node_modules/swiper/dist/css/swiper.css
// module id = 449
// module chunks = 3 4 7 8 9 10 12 13 15 16 19 27